module.exports = __webpack_public_path__ + "img/wizard.6228c60c.png";